import CircularProgress from '@mui/material/CircularProgress';

export default function CircularLoading({ color, width, height }) {
  return (
    <CircularProgress
      style={{
        width,
        height,
        color
      }}
    />
  );
}
